export class Unites {
  codeCourt: string;
  codeHecate: number;
  designation: string;
  id: number;
  constructor(codeCourt: string, codeHecate: number, designation: string, id: number) {
    this.codeCourt = codeCourt;
    this.codeHecate = codeHecate;
    this.designation = designation;
    this.id = id;
  }
}
